<template>
  <div>
    <!-- {{idData}} -->
    <!-- <b-button @click="generatePdf" variant="primary"> Download PDF </b-button> -->
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import pdfMake from "pdfmake/build/pdfmake";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { mapActions, mapGetters } from "vuex";

let APIDomain = new URL(window.location.href);
if (APIDomain.hostname != "localhost") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

export default {
  components: {
    Loader,
  },
  data() {
    return {
      userid:null,
      username:null,
      isLoadingData: false,
      monthNames: [
        "January",
        "Februrary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      idData: null,
      dataArray: [],
      dataPO: [],
      dataPORecipt: [],
      dataPOOrder: [],
      dataPOProduct: [],
    };
  },

  computed: {
    ...mapGetters("session", ["userData"]),
  },

  methods: {
    ...mapActions("session", ["showNotification"]),
    async generatePdf() {
      try {
        this.isLoadingData = true;
        const content = [];

        // Sample data array to iterate over
        const dataArray = this.dataArray;
        // [

        //   {
        //     noPo: "01/OPS/11/2024",
        //     noBox: "1",
        //     countBox: "5",
        //     imageSrc: "path/to/logo.png", // Adjust this path to your actual logo image
        //     namaCustomer: "PC Ketapang II LTD (Petronas Carigali Indonesia)",
        //     identitasPenerima: {
        //       nama: "Andri Sita",
        //       phone: "0811 874 121",
        //       alamat:
        //         "Talavera Office Park, Talavera\nSuite, 3rd Floor (Andriana)\nJl. Letjen TB Simatupang Kav.\n22-26, Cilandak, Jakarta Selatan\n12430, Indonesia",
        //     },
        //     identitasPenagihan: {
        //       nama: "Andri Sita",
        //       phone: "0811 874 121",
        //       alamat:
        //         "Talavera Office Park, Talavera\nSuite, 3rd Floor (Andriana)\nJl. Letjen TB Simatupang Kav.\n22-26, Cilandak, Jakarta Selatan\n12430, Indonesia",
        //     },
        //     rincianOrder: {
        //       tanggalOrder: "1 November 2024",
        //       jumlahOrder: "60",
        //       hargaSatuan: "Rp130,000",
        //       tanggalDiterima: "19 November 2024",
        //       pengelompokanKemasan: "Per Ukuran",
        //       kemasanPengiriman: "Kardus",
        //       totalHarga: "Rp7,800,000",
        //     },
        //     rincianProduk: {
        //       noSample: "9621",
        //       kategoriProduk: "T-Shirt S/S [Bahan Tipis]",
        //       keteranganProduk: "T-Shirt S/S (Biru)",
        //       merek: "Valino",
        //       material: "Active Dry",
        //       totalBordir: "Sablon 3 Titik",
        //       keteranganBordir: "-",
        //     },
        //   },
        //   {
        //     noPo: "01/OPS/11/2024",
        //     noBox: "1",
        //     countBox: "5",
        //     imageSrc: "path/to/logo.png", // Adjust this path to your actual logo image
        //     namaCustomer: "PC Ketapang II LTD (Petronas Carigali Indonesia)",
        //     identitasPenerima: {
        //       nama: "Andri Sita",
        //       phone: "0811 874 121",
        //       alamat:
        //         "Talavera Office Park, Talavera\nSuite, 3rd Floor (Andriana)\nJl. Letjen TB Simatupang Kav.\n22-26, Cilandak, Jakarta Selatan\n12430, Indonesia",
        //     },
        //     identitasPenagihan: {
        //       nama: "Andri Sita",
        //       phone: "0811 874 121",
        //       alamat:
        //         "Talavera Office Park, Talavera\nSuite, 3rd Floor (Andriana)\nJl. Letjen TB Simatupang Kav.\n22-26, Cilandak, Jakarta Selatan\n12430, Indonesia",
        //     },
        //     rincianOrder: {
        //       tanggalOrder: "1 November 2024",
        //       jumlahOrder: "60",
        //       hargaSatuan: "Rp130,000",
        //       tanggalDiterima: "19 November 2024",
        //       pengelompokanKemasan: "Per Ukuran",
        //       kemasanPengiriman: "Kardus",
        //       totalHarga: "Rp7,800,000",
        //     },
        //     rincianProduk: {
        //       noSample: "9621",
        //       kategoriProduk: "T-Shirt S/S [Bahan Tipis]",
        //       keteranganProduk: "T-Shirt S/S (Biru)",
        //       merek: "Valino",
        //       material: "Active Dry",
        //       totalBordir: "Sablon 3 Titik",
        //       keteranganBordir: "-",
        //     },
        //   },

        // ];

        console.log(dataArray);

        dataArray.forEach((data, index) => {
          // Adding the original content here
          content.push(
            {
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: "PT BINABUSANA INTERNUSA",
                      alignment: "center",
                      bold: true,
                      fontSize: 16,
                      margin: [0, 5, 0, 5],
                    },
                  ],
                  [
                    {
                      text: "DETAIL PURCHASE ORDER",
                      alignment: "center",
                      bold: true,
                      fontSize: 14,
                      margin: [0, 5, 0, 5],
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => "#000000",
                vLineColor: () => "#000000",
              },
              margin: [0, 0, 0, 10],
            },
            {
              table: {
                widths: ["20%", "80%"],
                body: [
                  [{ text: "No. PO/SPK/SKO", bold: true }, data.noPo],
                  [{ text: "Nama Customer", bold: true }, data.namaCustomer],
                  [
                    { text: "Jenis Customer", bold: true },
                    {
                      text: data.statusCustomer,
                    },
                  ],
                ],
              },
              layout: "noBorders",
              margin: [0, 0, 0, 10],
            },
            {
              columns: [
                {
                  width: "50%",
                  stack: [
                    {
                      text: "IDENTITAS PENERIMA",
                      bold: true,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      table: {
                        widths: ["40%", "60%"],
                        body: [
                          [
                            { text: "Nama", bold: true },
                            data.identitasPenerima.nama,
                          ],
                          [
                            { text: "No. Telephone/E-mail", bold: true },
                            data.identitasPenerima.phone,
                          ],
                          [
                            { text: "Alamat Pengiriman", bold: true },
                            data.identitasPenerima.alamat,
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
                {
                  width: "50%",
                  stack: [
                    {
                      text: "IDENTITAS PENAGIHAN PEMBAYARAN",
                      bold: true,
                      margin: [0, 0, 0, 5],
                    },
                    {
                      table: {
                        widths: ["40%", "60%"],
                        body: [
                          [
                            { text: "Nama", bold: true },
                            data.identitasPenagihan.nama,
                          ],
                          [
                            { text: "No. Telephone/E-mail", bold: true },
                            data.identitasPenagihan.phone,
                          ],
                          [
                            { text: "Alamat Penagihan", bold: true },
                            data.identitasPenagihan.alamat,
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
              ],
            },
            {
              text: "RINCIAN ORDER",
              bold: true,
              margin: [0, 20, 0, 10],
            },
            {
              columns: [
                {
                  width: "50%",
                  stack: [
                    {
                      table: {
                        widths: ["50%", "50%"],
                        body: [
                          [
                            { text: "Tanggal Order", bold: true },
                            { text: data.rincianOrder.tanggalOrder },
                          ],
                          [
                            { text: "Jumlah Order (Pcs)", bold: true },
                            { text: data.rincianOrder.jumlahOrder },
                          ],
                          [
                            { text: "Harga Satuan/pcs*", bold: true },
                            { text: data.rincianOrder.hargaSatuan },
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
                {
                  width: "50%",
                  stack: [
                    {
                      table: {
                        widths: ["50%", "50%"],
                        body: [
                          [
                            { text: "Tanggal Diterima", bold: true },
                            { text: data.rincianOrder.tanggalDiterima },
                          ],
                          [
                            { text: "Pengelompokan Kemasan", bold: true },
                            { text: data.rincianOrder.pengelompokanKemasan },
                          ],
                          [
                            { text: "Kemasan Pengiriman", bold: true },
                            { text: data.rincianOrder.kemasanPengiriman },
                          ],
                          [
                            { text: "Total Harga Order*", bold: true },
                            { text: data.rincianOrder.totalHarga },
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
              ],
              margin: [0, 0, 0, 0],
            },
            {
              text: "* Belum termasuk PPN 11%",
              italics: true,
              margin: [0, 0, 0, 10],
            },
            {
              text: "RINCIAN PRODUK",
              bold: true,
              margin: [0, 20, 0, 10],
            },
            {
              columns: [
                {
                  width: "80%",
                  stack: [
                    {
                      table: {
                        widths: ["25%", "75%"],
                        body: [
                          [
                            { text: "No. Sample", bold: true },
                            data.rincianProduk.noSample,
                          ],
                          [
                            { text: "Kategori Produk", bold: true },
                            data.rincianProduk.kategoriProduk,
                          ],
                          [
                            { text: "Keterangan Produk", bold: true },
                            data.rincianProduk.keteranganProduk,
                          ],
                          [
                            { text: "Merek", bold: true },
                            data.rincianProduk.merek,
                          ],
                          [
                            { text: "Material / Fabric", bold: true },
                            data.rincianProduk.material,
                          ],
                          [
                            { text: "Total Bordir", bold: true },
                            data.rincianProduk.totalBordir,
                          ],
                          [
                            { text: "Keterangan Bordir", bold: true },
                            data.rincianProduk.keteranganBordir,
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
                {
                  width: "20%",
                  stack: [
                    {
                      table: {
                        widths: ["100%"],
                        body: [
                          [
                            {
                              text: "Swatches",
                              bold: true,
                              alignment: "center",
                              margin: [0, 60, 0, 60],
                              border: [true, true, true, true],
                            },
                          ],
                        ],
                      },
                      layout: {
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => "#000000",
                        vLineColor: () => "#000000",
                      },
                    },
                  ],
                },
              ],
            },
            {
              text: "Lampiran Pendukung",
              bold: true,
              margin: [0, 0, 0, 5],
            },
            {
              table: {
                widths: ["20%", "20%", "20%"],
                body: [
                  [
                    {
                      columns: [
                        {
                          svg: data.svgPO,
                          width: 10,
                        },
                        { text: "PO/SPK/SPO", margin: [5, 0] },
                      ],
                    },
                    {
                      columns: [
                        {
                          svg: data.svgUkur,
                          width: 10,
                        },
                        { text: "Data Ukur", margin: [5, 0] },
                      ],
                    },
                    { text: "Lainnya _______", alignment: "center" },
                  ],
                ],
              },
              layout: "noBorders",
              margin: [0, 0, 0, 5],
            },

            {
              text: `Catatan:  ${data.note}`, // Dynamically include the note
              italics: true,
              margin: [0, 0, 0, 5],
            },
            {
              stack: [
                // ===== Row 1 =====
                {
                  columns: [
                    {
                      text: "Dibuat Oleh,",
                      alignment: "center",
                    },
                    {
                      text: "",
                    },
                    {text: "Diperiksa Oleh,",
                      alignment: "left"},
                    
                  ]
                },

                // ===== Row 2 =====
                {
                  columns: [
                    {
                      text: `\n\n\n\n(${data.sales})\nSales Executive`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n(${this.leader_name || ' Dwi Paryanti '})\nSection Head`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n( Widya Ranitya )\nDept Head`,
                      alignment: "center",
                    }
                  ]
                },

                // ===== Row 3 =====
                {
                  text: "\n\nDisetujui Oleh,",
                  alignment: "center",
                },

                // ===== Row 4 =====
                {
                  columns: [
                    {
                      text: `\n\n\n\n(${data.divHead || ' Lidya Ridiani '})\nDivision Head Sales`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n(${data.coo || ' Jason Edward Wuysang '})\nCOO`,
                      alignment: "center",
                    }
                  ]
                }
              ]
            },
            // {
            //   text: "STANDARDIZATION APPROVAL",
            //   bold: true,
            //   margin: [0, 20, 0, 10],
            // },
            // {
            //   columns: [
            //     {
            //       text: "Disusun Oleh,\n\n\n\n(Nurcholifah)\nUniform Operation",
            //       alignment: "center",
            //     },
            //     {
            //       text: "Diverifikasi Oleh,\n\n\n\n(Sri Hartini)\nUniform Operation",
            //       alignment: "center",
            //     },
            //     {
            //       text: "Diketahui Oleh,\n\n\n\n(Veronika Janus)\nCGC",
            //       alignment: "center",
            //     },
            //   ],
            // }
          );

          // Adding a page break if not the last item
          if (index < dataArray.length - 1) {
            content.push({ text: "", pageBreak: "after" });
          }
        });

        const docDefinition = {
          defaultStyle: {
            fontSize: 10,
          },
          content: content,
          pageSize: "A4",
          pageMargins: [10, 10, 10, 10], // Adjust margins as needed
        };

        console.log(docDefinition);
        console.log(content);
        // Generate and download the PDF
        // pdfMake.createPdf(docDefinition).open(`${this.dataPO[0].customer_name}_${this.dataPO[0].po}.pdf`);
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank"; // Opens in a new tab
          a.download = `${this.dataPO[0].customer_name}_${this.dataPO[0].po}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // Clean up the URL
        });
        this.isLoadingData = false;
      } catch (error) {
        this.isLoadingData = false;
        this.showNotification({ type: "error", message: error });
      }
    },

    loadDataPO() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPO, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataPO = rsp.data.payload;
          this.loadDataPORecip();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },
    loadDataPORecip() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPORecipt, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataPORecipt = rsp.data.payload;
          this.loadDataPOOrder();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadDataPOOrder() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPOOrder, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataPOOrder = rsp.data.payload;
          this.loadDataPOProduct();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadDataPOProduct() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPOProduct, {
        idData: this.idData,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataPOProduct = rsp.data.payload;
          this.loadPdfArray();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadPdfArray() {
      this.dataArray = [];
      for (let a = 0; a < this.dataPOProduct.length; a++) {
        let svgPO = "";
        let svgUkur = "";
        if (this.dataPO[0].spk_po) {
          svgPO =
            '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
        } else {
          svgPO = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M18.3 5.71L12 12l6.3 6.3-1.42 1.42L12 13.41l-6.3 6.3L4.29 18.3 10.59 12 4.29 5.71 5.71 4.29 12 10.59l6.3-6.3z"/></svg>';
        }
        if (this.dataPO[0].measure_data) {
          svgUkur =
            '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
        } else {
          svgUkur = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M18.3 5.71L12 12l6.3 6.3-1.42 1.42L12 13.41l-6.3 6.3L4.29 18.3 10.59 12 4.29 5.71 5.71 4.29 12 10.59l6.3-6.3z"/></svg>';
        }
        let leader_name = '____________________'
        if (this.dataPO[0].leader_name) {
          leader_name = this.dataPO[0].leader_name
        }
        this.dataArray.push({
          noPo: this.dataPO[0].po,
          namaCustomer: this.dataPO[0].customer_name,
          statusCustomer: this.dataPO[0].type_customer,
          note: this.dataPO[0].note,
          sales: this.dataPO[0].created_by_name,
          leader_sales: leader_name,
          svgPO: svgPO,
          svgUkur: svgUkur,
          identitasPenerima: {
            nama: this.dataPORecipt[0].name,
            phone: this.dataPORecipt[0].name_info,
            alamat: this.dataPORecipt[0].address,
          },
          identitasPenagihan: {
            nama: this.dataPORecipt[1].name,
            phone: this.dataPORecipt[1].name_info,
            alamat: this.dataPORecipt[1].address,
          },

          rincianOrder: {
            tanggalOrder: this.FormatDate(this.dataPOOrder[a].order_date),
            jumlahOrder: this.dataPOOrder[a].order_qty,
            hargaSatuan: parseFloat(this.dataPOOrder[a].price_pcs)
              .toString()
              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
            tanggalDiterima: this.FormatDate(this.dataPOOrder[a].delivery_date),
            pengelompokanKemasan: this.dataPOOrder[a].packaging_group,
            kemasanPengiriman: this.dataPOOrder[a].packaging_type,
            totalHarga: ((parseFloat(this.dataPOOrder[a].price_pcs)) * (parseInt(this.dataPOOrder[a].order_qty)))
              .toString()
              .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
          },
          rincianProduk: {
            noSample: this.dataPOProduct[a].sample_no,
            kategoriProduk: this.dataPOProduct[a].product_category,
            keteranganProduk: this.dataPOProduct[a].product_info,
            merek: this.dataPOProduct[a].brand,
            material: this.dataPOProduct[a].fabric,
            totalBordir: this.dataPOProduct[a].embro_total,
            keteranganBordir: this.dataPOProduct[a].embro_info,
          },
        });
      }
      console.log(this.dataArray);
      this.generatePdf();
    },

    async setData() {
      this.loadDataPO()
    },
    FormatDate(value) {
      if (value == null || value == undefined || value == "") {
        return " ";
      } else {
        let date = new Date(value);
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = day + " " + bulan + " " + year;
        return date;
      }
    },
  },
  created() {
    this.userid = this.userData.username;
    this.username = this.userData.fullname;
    // if (this.$route.query.idData) {
    //   this.idData = this.$route.query.idData;
    //   this.setData();
    // }
    EventBus.$on("open-ketpo", (data) => {
      console.log(data);
      this.idData = data;
      this.setData();
    });
  },

  beforeDestroy() {
    EventBus.$off("open-ketpo");
  },
};
</script>

<style>
/* Optional styles for your button */
</style>
